import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "contexts";
import { NotificationUIModelExtended } from "types/notification";

export function useGetActiveNotificationList({ isAuthorized = false }: { isAuthorized?: boolean }) {
  const { apiService } = useAppContext();
  return useQuery<NotificationUIModelExtended[]>({
    queryKey: ["active-notification-list"],
    queryFn: async () => {
      try {
        const baseUrl = isAuthorized
          ? "/notification/active-notifications-private"
          : "/notification/active-notifications-public";
        const response = await apiService.request(baseUrl, {
          method: "GET",
        });

        const data = await response?.json();

        if (!response?.ok || !data) {
          return Promise.reject(data);
        }

        return data ?? [];
      } catch (error) {
        console.error("Error fetching active notifications:", error);
        return [];
      }
    },
    retry: false,
    initialData: [],
    enabled: false,
  });
}
